module.exports = __webpack_public_path__ + "img/hudson-hintze-vpxeE7s-my4-unsplash.18c8cf03.webp";